import React from "react";
//#region types
import { TimeReportInvoiceInfoProps } from "models/propTypes/timeReportingPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";
import { WintSuperkollAPIModel, WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";

const InvoicePickerItem: React.FC<TimeReportInvoiceInfoProps> = (props) => {
  const { invoiceInfo } = props;

  return invoiceInfo ? (
    <Grid item xs container className={cssExports.searchResultTextContainer}>
      <Grid item xs={8} container direction={"column"}>
        <Grid item className={cssExports.invoicePickerItemText}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReporting.InvoiceWithSerialNumber, "", {
            serialNumber: invoiceInfo.serialNumber.toString(),
          })}
          {", "}
          {invoiceInfo.invoiceState === WintSuperkollAPIModel.InvoiceStatus.Paid &&
          invoiceInfo.creditingState !== WintSuperkollAPIModelTimeReporting.InvoiceCreditingState.NotCredited
            ? LocalizationHelperInstance.getFormattedMessage(
                `TimeReportingProject.CreditingState_${invoiceInfo.creditingState}`
              )
            : LocalizationHelperInstance.getFormattedMessage(`Invoice.State_${invoiceInfo.invoiceState}`)}
        </Grid>
        <Grid item className={cssExports.invoicePickerItemDescription}>
          {LocalizationHelperInstance.getFormattedDate(invoiceInfo.invoiceDate)}, {invoiceInfo.customerName}
        </Grid>
      </Grid>
      <Grid item xs={4} container direction={"column"} className={cssExports.invoicePickerAmountContainer}>
        <Grid item className={cssExports.invoicePickerItemDescription}>
          {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Amount)}
        </Grid>
        <Grid item className={cssExports.invoicePickerAmountText}>
          {LocalizationHelperInstance.getFormattedCurrency(invoiceInfo.amount)}
        </Grid>
      </Grid>
    </Grid>
  ) : (
    <></>
  );
};

export default InvoicePickerItem;
